module.exports = __webpack_public_path__ + "static/media/new-brand-logo.dd86cbd2.svg";